// 會議頁自己的按鈕圖示（內嵌 SVG，不另外裝圖示套件）。
// 線條用 currentColor，顏色跟著按鈕的 color 走。
import React from "react";

const Svg = ({ children, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    {children}
  </svg>
);

/** 白板（畫筆） */
export const PencilIcon = () => (
  <Svg>
    <path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    <path d="m15 5 4 4" />
  </Svg>
);

/** 全部靜音：標準的麥克風加斜線（「所有人」由按鈕提示文字說明） */
export const MuteAllIcon = () => (
  <Svg>
    <path d="M2 2l20 20" />
    <path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2" />
    <path d="M5 10v2a7 7 0 0 0 12 5" />
    <path d="M15 9.34V5a3 3 0 0 0-5.68-1.33" />
    <path d="M9 9v3a3 3 0 0 0 5.12 2.12" />
    <path d="M12 19v3" />
  </Svg>
);

/** 移除參與者：人像加 × */
export const RemoveUserIcon = () => (
  <Svg>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="m17 8 5 5" />
    <path d="m22 8-5 5" />
  </Svg>
);

/** 名單裡每一列的「移除」 */
export const CloseIcon = () => (
  <Svg size={18}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </Svg>
);
